export default "__VITE_ASSET__D5OfQJH0__"